import { todayInTimezone, type ISODate } from "@clarent/scheduling";
import { useEffect, useState } from "react";

/** Decision D2: the shop's timezone. Mirrors SHOP_TIMEZONE in the backend. */
export const SHOP_TIMEZONE = "Europe/London";

export function todayISO(): ISODate {
  return todayInTimezone(SHOP_TIMEZONE);
}

/** Today's date, re-evaluated every minute so an open tab rolls over at midnight. */
export function useToday(): ISODate {
  const [today, setToday] = useState(todayISO);
  useEffect(() => {
    const id = window.setInterval(() => {
      const next = todayISO();
      setToday((prev) => (prev === next ? prev : next));
    }, 60_000);
    return () => window.clearInterval(id);
  }, []);
  return today;
}
